let quesList = [
  {
    id: 'Q_10209389212031',
    subjectId: 102,
    knowledgePoints: null,
    knowledgePointsNew: [],
    testMethods: [],
    solutionMethods: [],
    resourceIds: null,
    resourceIndex: 0,
    listenUrl: null,
    listenName: null,
    listenSeconds: 0,
    exploreSeconds: 0,
    answersSeconds: 0,
    paperIds: ['P_10200129554669-3', 'P_10200129554669-4'],
    books: null,
    booksNew: null,
    contentTypeId: 1021002,
    contentType2Id: 0,
    difficultyInt: 1,
    description: '算一算，填一填。',
    notFitMobile: 0,
    seconds: 71,
    complex: 0,
    nid: null,
    lastEditorId: null,
    finalAuditorId: null,
    roughAuditorIds: null,
    content: {
      content: '',
      contentDesc: '',
      analysis: '',
      subContents: [
        {
          content:
            '<p>69-24＝__$$__</p><p>先算：69-20＝__$$__</p><p>再算：__$$__-__$$__＝__$$__</p>',
          answers: [
            {
              answer: '45',
              subAnswers: ['45'],
              richTexts: null,
              scorePercentage: 1,
              classification: '',
              knowledgePoints: null,
              knowledgePointsNew: [
                {
                  id: 'KP_10200051370727',
                  tagId: 0,
                  main: 1,
                  featureIds: ['KPF_10200000028204']
                }
              ],
              testMethods: [],
              solutionMethods: [],
              classificationListenUrl: null,
              variantId: null,
              top10: null,
              stepNum: null,
              variants: null,
              groupId: null,
              shiftNum: null
            },
            {
              answer: '49',
              subAnswers: ['49'],
              richTexts: null,
              scorePercentage: 1,
              classification: '',
              knowledgePoints: null,
              knowledgePointsNew: [
                {
                  id: 'KP_10200051366241',
                  tagId: 0,
                  main: 1,
                  featureIds: ['KPF_10200000028204']
                }
              ],
              testMethods: [],
              solutionMethods: [],
              classificationListenUrl: null,
              variantId: null,
              top10: null,
              stepNum: null,
              variants: null,
              groupId: null,
              shiftNum: null
            },
            {
              answer: '49',
              subAnswers: ['49'],
              richTexts: null,
              scorePercentage: 1,
              classification: '',
              knowledgePoints: null,
              knowledgePointsNew: [],
              testMethods: [],
              solutionMethods: [],
              classificationListenUrl: null,
              variantId: null,
              top10: null,
              stepNum: null,
              variants: null,
              groupId: null,
              shiftNum: null
            },
            {
              answer: '4',
              subAnswers: ['4'],
              richTexts: null,
              scorePercentage: 1,
              classification: '',
              knowledgePoints: null,
              knowledgePointsNew: [],
              testMethods: [],
              solutionMethods: [],
              classificationListenUrl: null,
              variantId: null,
              top10: null,
              stepNum: null,
              variants: null,
              groupId: null,
              shiftNum: null
            },
            {
              answer: '45',
              subAnswers: ['45'],
              richTexts: null,
              scorePercentage: 1,
              classification: '',
              knowledgePoints: null,
              knowledgePointsNew: [
                {
                  id: 'KP_10200051368696',
                  tagId: 0,
                  main: 1,
                  featureIds: ['KPF_10200000028204']
                }
              ],
              testMethods: [],
              solutionMethods: [],
              classificationListenUrl: null,
              variantId: null,
              top10: null,
              stepNum: null,
              variants: null,
              groupId: null,
              shiftNum: null
            }
          ],
          subContentTypeId: 4,
          analysis:
            '<p>提示：此题考查的是两位数减两位数。</p><p>解答：计算69-24时，先算69-20＝49，再算49-4＝45，所以69-24＝45。故此题答案为45、49、49、4、45。</p>',
          optionType: 'word',
          options: [],
          hideOptionNumber: 0,
          listenUrl: '',
          listenName: '',
          listenSeconds: 0,
          intervene: null,
          clue: null,
          coverPic: null,
          exploreSeconds: 0,
          answersSeconds: 0,
          oralDict: {
            seconds: null,
            variables: null,
            keywords: null,
            options: null,
            voiceText: null,
            sentencePatterns: null,
            picUrl: null,
            picName: null,
            beginListenUrl: null,
            endListenUrl: null,
            scorePercentage: null,
            readySeconds: null,
            listenFile: null,
            contentDesc: null,
            answers: null,
            voiceTextsNew: null,
            jsgf: null,
            videoUrl: null,
            videoCoverUrl: null,
            highlightPos: null,
            sceneDescription: null,
            sceneName: null
          },
          submitWays: [0],
          tags: null,
          analysisList: null,
          pictureUrl: '',
          isUnionScore: null,
          extras: {},
          tagsDesc: [],
          unionScore: false,
          subStandardAnswersMap: {
            '0': [
              {
                answer: '45',
                subAnswers: ['45'],
                richTexts: null,
                scorePercentage: 1,
                classification: '',
                knowledgePoints: null,
                knowledgePointsNew: [
                  {
                    id: 'KP_10200051370727',
                    tagId: 0,
                    main: 1,
                    featureIds: ['KPF_10200000028204']
                  }
                ],
                testMethods: [],
                solutionMethods: [],
                classificationListenUrl: null,
                variantId: null,
                top10: null,
                stepNum: null,
                variants: null,
                groupId: null,
                shiftNum: null
              },
              {
                answer: '49',
                subAnswers: ['49'],
                richTexts: null,
                scorePercentage: 1,
                classification: '',
                knowledgePoints: null,
                knowledgePointsNew: [
                  {
                    id: 'KP_10200051366241',
                    tagId: 0,
                    main: 1,
                    featureIds: ['KPF_10200000028204']
                  }
                ],
                testMethods: [],
                solutionMethods: [],
                classificationListenUrl: null,
                variantId: null,
                top10: null,
                stepNum: null,
                variants: null,
                groupId: null,
                shiftNum: null
              },
              {
                answer: '49',
                subAnswers: ['49'],
                richTexts: null,
                scorePercentage: 1,
                classification: '',
                knowledgePoints: null,
                knowledgePointsNew: [],
                testMethods: [],
                solutionMethods: [],
                classificationListenUrl: null,
                variantId: null,
                top10: null,
                stepNum: null,
                variants: null,
                groupId: null,
                shiftNum: null
              },
              {
                answer: '4',
                subAnswers: ['4'],
                richTexts: null,
                scorePercentage: 1,
                classification: '',
                knowledgePoints: null,
                knowledgePointsNew: [],
                testMethods: [],
                solutionMethods: [],
                classificationListenUrl: null,
                variantId: null,
                top10: null,
                stepNum: null,
                variants: null,
                groupId: null,
                shiftNum: null
              },
              {
                answer: '45',
                subAnswers: ['45'],
                richTexts: null,
                scorePercentage: 1,
                classification: '',
                knowledgePoints: null,
                knowledgePointsNew: [
                  {
                    id: 'KP_10200051368696',
                    tagId: 0,
                    main: 1,
                    featureIds: ['KPF_10200000028204']
                  }
                ],
                testMethods: [],
                solutionMethods: [],
                classificationListenUrl: null,
                variantId: null,
                top10: null,
                stepNum: null,
                variants: null,
                groupId: null,
                shiftNum: null
              }
            ]
          }
        }
      ]
    },
    docId: 'Q_10209389212031',
    version: 3,
    wordId: null,
    pictureUrl: null,
    tagId: null,
    tagCode: null,
    createdAt: 1502503252815,
    deletedAt: null,
    olCreatedAt: 1509766240066,
    olUpdatedAt: 1509766240066,
    sentenceIds: null,
    sentenceContents: null,
    practiceTypeIds: null,
    categoryId: 0,
    fromId: 7,
    paragraph: null,
    articleName: null,
    descriptionFile: {
      fileId: '',
      url: '',
      filename: '',
      seconds: 0
    },
    analysisSeconds: 0,
    readySeconds: 0,
    wikiType: null,
    others: null,
    extras: {
      seconds: 78,
      draft_md5: '10c25339b4071bf1d18a08733d27ed66'
    },
    skillIds: null,
    abilities: null,
    weighted: null,
    additions: null,
    questionId: null,
    bookCatalogIds: null,
    previousId: null,
    variantIds: null,
    errorFactorIds: null,
    intervene: null,
    clue: null,
    coverPic: null,
    answers: [['45', '49', '49', '4', '45']],
    tags: []
  }
]
export default quesList
